export let basicProps = {
    id: 0,
    article_title: '',
    wrrite_by_name: '',
    wrrite_by_profile_link: '',
    article_content: ''
}


// WEBPACK FOOTER //
// ./src/store/modules/articles/properties.js